export const getLongDateTime = (date: string) => {
  const dateObj = new Date(date);
  const locale = 'pt-BR';
  const timeZone = 'America/Sao_Paulo';
  const formattedDate = dateObj.toLocaleDateString(locale, {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const formattedTime = dateObj.toLocaleTimeString(locale, {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${formattedDate} às ${formattedTime}`;
};
